import React from "react";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import { Button } from "@fluentui/react-northstar";

export default function AwardAmountRange(props) {
  const program = props.program;
  const budgetList = props.budgetList;
  const recipients = props.recipients;
  const callback = props.callback;

  const [pointsPer, setPointsPer] = React.useState(
    program.awardAmountPolicy?.range?.minimum
  );
  const [totalPoints, setTotalPoints] = React.useState(
    pointsPer * recipients.length
  );
  const [projectedBalance, setProjectedBalance] = React.useState(
    budgetList.balance - program.awardAmountPolicy?.range?.minimum
  );

  const intl = useIntl();
  const messages = defineMessages({
    alertPointsExceeded: {
      id: "app.awardAmountRange.alertPointsExceeded",
      defaultMessage: "Points to be awarded exceeds points available.",
    },
    alertInvalidPointAmount: {
      id: "app.awardAmountRange.alertInvalidPointAmount",
      defaultMessage: "You must select a valid number of points per recipient.",
    },
    alertInvalidPointRange: {
      id: "app.awardAmountRange.alertInvalidPointRange",
      defaultMessage:
        "You must select a value between {programMin} and {programMax}",
    },
  });

  const getMinimumRange = () => {
    const minimum = program.awardAmountPolicy?.range?.minimum;
    if (budgetList.balance >= minimum * recipients.length) {
      return minimum;
    }
    //else budget is  invalid, should have not be shown.
  };

  const getMaximumRange = () => {
    const maximum = program.awardAmountPolicy?.range?.maximum;
    if (budgetList.balance >= maximum * recipients.length) {
      return maximum;
    }
    return budgetList.balance / recipients.length;
  };

  const pointsValueChange = (newVal) => {
    const calculatedTotalPoints = newVal * recipients.length;

    if (calculatedTotalPoints > budgetList.balance) {
      alert(intl.formatMessage(messages.alertPointsExceeded));
      return false;
    }

    setProjectedBalance(budgetList.balance - calculatedTotalPoints);

    setPointsPer(newVal);
    setTotalPoints(calculatedTotalPoints);
  };

  const applyButtonClick = () => {
    if (totalPoints === 0 && program.awardAmountPolicy.required) {
      alert(intl.formatMessage(messages.alertInvalidPointAmount));
      return false;
    }

    if (
      pointsPer < program.awardAmountPolicy.range.minimum ||
      pointsPer > program.awardAmountPolicy.range.maximum
    ) {
      alert(
        intl.formatMessage(messages.alertInvalidPointRange, {
          programMin: program.awardAmountPolicy.range.minimum,
          programMax: program.awardAmountPolicy.range.maximum,
        })
      );
      return false;
    }

    if (totalPoints > budgetList.balance) {
      alert(intl.formatMessage(messages.alertPointsExceeded));
      return false;
    }

    callback(pointsPer);
  };

  return (
    <>
      {budgetList && (
        <>
          {/* TODO: Add dynamic translation */}
          <p>
            <FormattedMessage
              id="app.awardAmountRange.pointRange"
              defaultMessage="Enter a value between {programMin} and {programMax}"
              values={{
                programMin: getMinimumRange(),
                programMax: getMaximumRange(),
              }}
            />
            :
          </p>
          <input
            type="number"
            className="border-2 my-2"
            value={pointsPer}
            onChange={(e) => {
              pointsValueChange(e.target.value);
            }}
            min={getMinimumRange()}
            max={getMaximumRange()}
          />
          <p>
            <b>
              <FormattedMessage
                id="app.awardAmountRange.totalPoints"
                defaultMessage="Total Points Awarded"
              />
              :{totalPoints.toLocaleString()}
            </b>
            <br />
            <b>
              {budgetList.displayBalance === true ? (
                <FormattedMessage
                  id="app.recognition.balance"
                  defaultMessage="Balance: {value}"
                  values={{
                    value: projectedBalance.toLocaleString(),
                  }}
                />
              ) : (
                ""
              )}
            </b>
          </p>
          <div className="mt-5 mb-5 text-center">
            <Button
              className="text-lg px-4 py-2 rounded primary-btn"
              onClick={() => {
                applyButtonClick();
              }}
            >
              <FormattedMessage
                id="app.awardAmountRange.apply"
                defaultMessage="Apply"
              />
            </Button>
          </div>
        </>
      )}
    </>
  );
}
